export const FAMILIES_RECEIVED = "FAMILIES_RECEIVED";
export const FAMILY_CREATED = "FAMILY_CREATED";
export const FAMILY_UPDATED = "FAMILY_UPDATED";
export const FAMILY_DELETED = "FAMILY_DELETED";
export const FAMILY_INVITE_SENT = "FAMILY_INVITE_SENT"